import { useMemo } from 'react';
import { z } from 'zod';

import { useChannelFieldSchemas } from './channel-refinements';

/**
 * Hook to create the validation schema for the budget recommendation form:
 * edits the budget on an existing campaign, so only the channel-specific
 * budget rules apply.
 */
export function useBudgetRecommendationSchema(channelSlug: string) {
  const { getBudgetSchema } = useChannelFieldSchemas();

  return useMemo(
    () => z.object({ budget: getBudgetSchema(channelSlug) }),
    [channelSlug, getBudgetSchema],
  );
}
